import * as actions from '../../redux/actions';

import React, { Component, useState } from 'react';

import { AndimarTitle } from '../../common/Title/AndimarTitle';
import CommonService from '../../../../services/commonService';
import HeroSection from '../../common/HeroSection/HeroSection';
import KuposHelmet from '../../../common/KuposHelmet';
import KuposTabs from '../../../common/KuposTabs';
import MultiSlider3 from '../../common/MultiSlider/MultiSlider3';
import ThemeFourTitle from '../common/ThemeFourTitle';
import address10 from '../../assets/andimar/favoriteDestinations/address10.jpg';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';
import getSlides from '../../functions/getSlides/getSlides';
import parcel1 from '../../assets/pullmansur/parcel/PullmandelSur-Website-HomeV2-Bloque-28.png';
import parcel10  from '../../assets/pullmansur/parcel/PullmandelSur-Website-HomeV2-Bloque-37.png';
import parcel11  from '../../assets/pullmansur/parcel/PullmandelSur-Website-HomeV2-Bloque-38.png';
import parcel12  from '../../assets/pullmansur/parcel/PullmandelSur-Website-HomeV2-Bloque-39.png';
import parcel13  from '../../assets/pullmansur/parcel/PullmandelSur-Website-HomeV2-Bloque-40.png';
import parcel2  from '../../assets/pullmansur/parcel/PullmandelSur-Website-HomeV2-Bloque-29.png';
import parcel3  from '../../assets/pullmansur/parcel/PullmandelSur-Website-HomeV2-Bloque-30.png';
import parcel4  from '../../assets/pullmansur/parcel/PullmandelSur-Website-HomeV2-Bloque-31.png';
import parcel5  from '../../assets/pullmansur/parcel/PullmandelSur-Website-HomeV2-Bloque-32.png';
import parcel6  from '../../assets/pullmansur/parcel/PullmandelSur-Website-HomeV2-Bloque-33.png';
import parcel7  from '../../assets/pullmansur/parcel/PullmandelSur-Website-HomeV2-Bloque-34.png';
import parcel8  from '../../assets/pullmansur/parcel/PullmandelSur-Website-HomeV2-Bloque-35.png';
import parcel9  from '../../assets/pullmansur/parcel/PullmandelSur-Website-HomeV2-Bloque-36.png';
import pullmansur from '../../assets/andimar/favoriteDestinations/andimar-offices-banner.jpg';

// import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
// const stepOneItem = [
// {
// title: 'Casa Matriz',
// image: parcel13,
// address: ' Jotabeche 124, Estación Central',
// phone: ' +56 9 8562 4442',
// icon1: '/assets/pullmansur/Home/PullmandelSur-Website-Home-SearchBar-DestinationIcon.png',
// mapLink:'https://www.google.com/maps/place/Jotabeche+124,+Santiago,+Estaci%C3%B3n+Central,+Regi%C3%B3n+Metropolitana,+Chile/@-33.4545389,-70.687898,17z'
// },
// ];
const stepTwoItem = [
{
title: 'Molina',
image: parcel5,
address: 'Luis Cruz Martinez 1487',
phone: '	75 2491 366',
mapLink:'https://maps.app.goo.gl/f2TQ4Z5NbuYwyvdr7'
},
{
title: 'Pelluhue',
image: parcel7,
address: 'Arturo Prat 580',
phone: '	9 6180 1580',
mapLink:'https://maps.app.goo.gl/QE6ppeDvjJ5KorTw7'
},
{
title: '	Parral',
image: parcel6,
address: '	Terminal de buses of. 2',
phone: '	73 2463258',
mapLink:'https://maps.app.goo.gl/8hnd59ecm5iAygsm9'
},
{
title: '	Hualane',
image: parcel12,
phone: '	75 2310387 - 75 2310076',
mapLink:'https://maps.app.goo.gl/a1DLGuakwXVjCjVD8'
},
{
title: '	Licanten',
image: parcel11,
phone: '	75 2310387 - 75 2310076',
mapLink:'https://maps.app.goo.gl/mVLTow3uumzTejpJ7'
},
{
title: '		Chanco',
image: parcel4,
address: 'Libertad 288',
phone: '9 6180 3759',
mapLink:'https://maps.app.goo.gl/wrLDo15MKLKAo6Ak6'
},
{
title: '		Talca',
image: parcel10,
address: '	2 Sur con 12 Oriente of. 14',
phone: '	71 2243431',
mapLink:'https://maps.app.goo.gl/oXUtudip8hrK9RJt5'
},
{
title: 'Curicó',
image: parcel3,
address: '	Camilo Enriquez 253',
phone: '	75 2310387 - 75 2310076',
mapLink:'https://maps.app.goo.gl/PdGhhhhYGv7WKEpE8'
},
{
title: '	San Javier',
image: parcel9,
address: '		Cancha de Carrera 2357',
phone: '	7	9 6180 1308',
mapLink:'https://maps.app.goo.gl/uk3dhX3nefKQ4LoM9'
},
{
title: 'Curanipe',
image: parcel2,
address: '	Arturo Prat S/N',
phone: '	9 6180 1568',
mapLink:'https://maps.app.goo.gl/oLBbjzKsYNrPfXeT9'
},
{
title: '	Rancagua',
image: parcel8,
address: '	Libertador Bernardo O’Higgins 0484 L25',
phone: '		9 6269 1106',
mapLink:'https://maps.app.goo.gl/7B8WeBQv8to7fEwh6'
},
{
title: '	Cauquenes',
image: parcel1,
address: '		Errazuriz 700 of. 3 y 4',
phone: '		9 6180 3676',
mapLink:'https://maps.app.goo.gl/SK3737CJSZ2hcw7C9'
}
];
// const stepThreeItem = [
// 	{
// 			title: 'Terminal Curicó',
// 			image: address6,
// 			address: ' Prat Nº 780 - of. 12.',
// 			phone: ' (+56 75) 274 69 89',
// 			timing:
// 					' Horario: 4:30 Hrs. - 20:30 Hrs. Lunes apertura a las 4:00 Hrs. y domingos a las 6:00 Hrs.',
// 			mapLink:
// 					'https://www.google.com/maps/place/34%C2%B05903.2%22S+71%C2%B01444.2%22W/@-34.9842315,-71.2543386,15z/data=!3m1!4b1!4m5!3m4!1s0x0:0x6464af35d1ea2c1a!8m2!3d-34.9842318!4d-71.2456053',
// 	},
// ];
const ThemeFourParcelScreen = props => {
const operator = CommonService.getLocal('op') || props.home.operator;
console.log('operator---', operator);
// const slides = [address3, address4, address4, address5];
const initalState = {
selectedTab: 1,
};
const [state, setState] = useState(initalState);
const tabs = ['Santiago', 'Zona Sur'];
const onTabChange = tab => {
setState({ ...state, selectedTab: tab });
};
return (
<div>
   <KuposHelmet />
   <HeroSection
   heroImage={getIcons('ParcelBanner', operator)}
   height={'43vh'}
   marginTop="-18px"
   title={'Encomiendas'}
   description={'Home / Encomiendas'}
   />
   <ThemeFourTitle title="Encomiendas" />
   <div className='new-container font11 lh-1-3 mb-30' >
      <p className='center-text '>Envía tus encomiendas con nosotros y retira en una de nuestras agencias a lo largo delpaís. Ofrecemos un servicio de calidad, garantizando la seguridad, responsabilidad y
         compromiso con nuestros clientes. Las encomiendas enviadas hacia la ciudad de Santiago
         llegan todas a la siguiente dirección: <br/><b><strong>Jotabeche 124, Estación Central, Metro Universidad de
         Santiago.</strong></b>
      </p>
      <div className="d-flex parcelscreen justify-content-center mt-30 mb-30">
         <div className="d-flex mar-20">
            <div>
               <img src ='/assets/pullmansur/parcel/icons/PullmandelSur-Website-HomeV2-Telefono.png' className='thicon'/>
            </div>
            <div className=''>
               <strong>Teléfonos</strong><br/>
               <strong>Fono fijo:	</strong> 582471691<br/>
               <strong>Fono móvil:	</strong> +569 8562 4442<br/>
            </div>
         </div>
         <div className="d-flex mal-20">
            <div>
               <img src ='/assets/pullmansur/parcel/icons/PullmandelSur-Website-HomeV2-Horario.png' className='thicon'/>
            </div>
            <div className=''>
               <strong>Horario de atención</strong><br/>
               Lun - vie 08:30 - 18:00 hrs<br/>
               Sábado 09:00 - 14:00 hrs<br/>
            </div>
         </div>
      </div>
   </div>
   <div className="new-container  customparcel">
      <KuposTabs
         tabs={tabs}
         onTabChange={onTabChange}
         selectedTab={state.selectedTab}
         operator={operator}
         />
      <div>
         {state.selectedTab === 1 ? (
         <div className="multi-slide-type-1"
         style={{
         width: '400px',
         margin:'40px auto', 
         }}
         >
         <div className="image-container">
            <img src="../../assets/pullmansur/parcel/PullmandelSur-Website-HomeV2-Bloque-40.png" />
         </div>
         <div 	style={{
         minHeight: '140px',
									padding:'15px',
									background:'rgb(243, 247, 255)',
         }}>
         <div
         className="font10 text-bold"
         style={{
         display: 'flex',
         alignItems: 'baseline',
         marginBottom: 15,
         lineHeight: 1.3,
         color: 'black',
         fontWeight: 'bold',
         }}
         >
         {"Casa Matriz"}
      </div>
      <div
      className="font10"
      style={{
      display: 'flex',
      alignItems: 'flex-start',
      marginBottom: 15,
      lineHeight: 1.3,
      }}
      >
      <img
      src={getIcons('Destination', props.operator)}
      alt=""
      style={{ marginRight: 5, width: props.iconwidth ? props.iconwidth:'15px' }}
      />
      <div>{"Jotabeche 124, Estación Central"}</div>
   </div>
   <div
   className="font10"
   style={{ display: 'flex', alignItems: 'flex-start', marginBottom: 15 }}
   >
   <img
   src={getIcons('TelephoneIcon', props.operator)}
   alt=""
   style={{ marginRight: 5, width: props.iconwidth ? props.iconwidth:'15px' }}
   />
   <div>{"+56 9 8562 4442"}</div>
</div>
</div>
<div className="font11" style={{ display: 'flex', alignItems: 'baseline',paddingBottom:'15px' ,paddingLeft:'15px',	background:'rgb(243, 247, 255)', }}>
<img
src={getIcons('BlueArrow', props.operator)}
alt=""
style={{ height: 10, width: 10, marginRight: 5 }}
/>
<a
href={"https://www.google.com/maps/place/Jotabeche+124,+Santiago,+Estaci%C3%B3n+Central,+Regi%C3%B3n+Metropolitana,+Chile/@-33.4545389,-70.687898,17z"}
target="_blank"
style={{ textDecoration: 'underline', color:'#ff0000'  }}
>
Ver mapa
</a>
</div>
</div>
// const stepOneItem = [
// 	{
// 	title: 'Casa Matriz',
// 	image: parcel13,
// 	address: ' Jotabeche 124, Estación Central',
// 	phone: ' +56 9 8562 4442',
// 	icon1: '/assets/pullmansur/Home/PullmandelSur-Website-Home-SearchBar-DestinationIcon.png',
// 	mapLink:'https://www.google.com/maps/place/Jotabeche+124,+Santiago,+Estaci%C3%B3n+Central,+Regi%C3%B3n+Metropolitana,+Chile/@-33.4545389,-70.687898,17z'
// 	},
// 	];
)  :
(
<MultiSlider3
//multiSlides={state.selectedTab == 1 ? stepOneItem : stepTwoItem}
multiSlides= {stepTwoItem}
textCard={true}
removeArrowOnDeviceType={[]}
andrimarArrowStyle
operator={operator}
vermapacolour={'red'}
minHeightCard={'0px'}
iconwidth={'15px'}
/>
)
}
</div>
</div>
</div>
);
};
/* istanbul ignore next */
function mapStateToProps(state) {
return {
home: state.home,
};
}
/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
return {
actions: bindActionCreators({ ...actions }, dispatch),
};
}
export default connect(mapStateToProps, mapDispatchToProps)(ThemeFourParcelScreen);


// WEBPACK FOOTER //
// ./src/features/themes/ThemeFour/ThemeFourPages/ThemeFourParcelScreen.js